<template>
    <div class="button-group">
        <slot />
    </div>
</template>
<style>
.button-group {
    @apply flex items-center;
}

.button-group > *:not(:last-child) {
    @apply border-r-0 rounded-r-none;
}

.button-group > *:not(:first-child) {
    @apply rounded-l-none;
}
</style>
